module.exports = __webpack_public_path__ + "img/drive-viewer-panel-1.e63326bd.svg";